<template>
  <div class="app-container">
    <el-card class="main-card">
      <div slot="header" class="clearfix">
        <span class="page-title">vivo广告组名称批量修改</span>
      </div>

      <div class="input-section">
        <el-form :model="form" label-width="100px" size="small">
          <el-form-item label="地区" style="margin-left: 0;">
            <el-select v-model="form.area" placeholder="请选择地区" class="custom-select" style="width: 250px;">
              <el-option label="浙江" value="1"></el-option>
              <el-option label="福建" value="2"></el-option>
              <el-option label="深圳" value="3"></el-option>
              <el-option label="苏州" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="账户名" style="margin-left: 0;">
            <el-input type="textarea" :rows="10" placeholder="请输入内容，每行一个" v-model="form.textListRaw" style="width: 100%;"
              spellcheck="false">
            </el-input>
          </el-form-item>

          <el-form-item label="后缀名称" style="margin-left: 0;">
            <el-input v-model="form.suffix" placeholder="请输入要拼接的后缀名称" style="width: 100%;"></el-input>
            <div class="el-form-item__tip">此后缀将追加到广告组名称后面</div>
          </el-form-item>

          <el-form-item label="字符偏移" style="margin-left: 0;">
            <el-input v-model="form.offset" placeholder="请输入字符偏移量，默认0" style="width: 100%;" type="number" :min="0">
            </el-input>
            <div class="el-form-item__tip">例如：2表示删除广告组名称最后2个字符后再拼接后缀</div>
          </el-form-item>

          <el-form-item style="margin-left: 0;">
            <el-button type="primary" @click="startBatchEdit" :loading="loading">开始批量修改</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 进度显示 -->
      <div v-if="progress.total > 0" class="progress-section">
        <el-card>
          <div slot="header">
            <span>执行进度</span>
            <el-button type="text" @click="progressLogVisible = !progressLogVisible" style="float: right; padding: 3px 0">
              {{ progressLogVisible ? '隐藏日志' : '显示日志' }}
            </el-button>
          </div>

          <div class="progress-info">
            <div class="progress-item">
              <span>总账户数：</span>
              <span class="progress-value">{{ progress.total }}</span>
            </div>
            <div class="progress-item">
              <span>已完成：</span>
              <span class="progress-value success">{{ progress.completed }}</span>
            </div>
            <div class="progress-item">
              <span>成功：</span>
              <span class="progress-value success">{{ progress.success }}</span>
            </div>
            <div class="progress-item">
              <span>失败：</span>
              <span class="progress-value failed">{{ progress.failed }}</span>
            </div>
            <div class="progress-item">
              <span>总广告组数：</span>
              <span class="progress-value">{{ progress.totalGroups }}</span>
            </div>
            <div class="progress-item">
              <span>已修改广告组：</span>
              <span class="progress-value">{{ progress.modifiedGroups }}</span>
            </div>
          </div>

          <el-progress :percentage="progress.percentage" :status="progress.status" :stroke-width="12"></el-progress>

          <div v-if="progressLogVisible" class="progress-log">
            <div v-for="(log, index) in progress.logs" :key="index" class="log-item" :class="log.type">
              <i :class="logIcon(log.type)"></i>
              <span>{{ log.time }}</span>
              <span>{{ log.message }}</span>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 结果展示 -->
      <div v-if="result.visible" class="result-section">
        <el-card>
          <div slot="header" class="clearfix">
            <span class="page-title">执行结果</span>
          </div>

          <div class="result-summary">
            <div class="result-stat success">
              <div class="result-stat-icon">
                <i class="el-icon-check"></i>
              </div>
              <div class="result-stat-content">
                <div class="result-stat-number">{{ result.success }}</div>
                <div class="result-stat-label">成功账户</div>
              </div>
            </div>

            <div class="result-divider"></div>

            <div class="result-stat failed">
              <div class="result-stat-icon">
                <i class="el-icon-close"></i>
              </div>
              <div class="result-stat-content">
                <div class="result-stat-number">{{ result.failed }}</div>
                <div class="result-stat-label">失败账户</div>
              </div>
            </div>

            <div class="result-divider"></div>

            <div class="result-stat total">
              <div class="result-stat-icon">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="result-stat-content">
                <div class="result-stat-number">{{ result.total }}</div>
                <div class="result-stat-label">总账户数</div>
              </div>
            </div>
          </div>

          <div v-if="result.failedDetails.length > 0" class="failed-details">
            <h3>失败详情</h3>
            <el-table :data="result.failedDetails" border size="small" style="width: 100%">
              <el-table-column prop="account" label="账户名" width="180"></el-table-column>
              <el-table-column prop="error" label="错误信息"></el-table-column>
            </el-table>
          </div>

          <div v-if="result.successDetails.length > 0" class="success-details">
            <h3>成功详情</h3>
            <el-table :data="result.successDetails" border size="small" style="width: 100%">
              <el-table-column prop="account" label="账户名" width="180"></el-table-column>
              <el-table-column prop="groups" label="修改广告组数"></el-table-column>
              <el-table-column prop="message" label="备注"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'BatchEditGroupName',
  data() {
    return {
      loading: false,
      form: {
        area: '1',
        textListRaw: '',
        textList: [],
        suffix: '',
        offset: 0
      },
      progress: {
        total: 0,
        completed: 0,
        success: 0,
        failed: 0,
        totalGroups: 0,
        modifiedGroups: 0,
        percentage: 0,
        status: '',
        logs: []
      },
      progressLogVisible: true,
      result: {
        visible: false,
        total: 0,
        success: 0,
        failed: 0,
        failedDetails: [],
        successDetails: []
      }
    }
  },
  watch: {
    'form.textListRaw': function (newVal) {
      this.form.textList = newVal.split('\n').filter(item => item.trim() !== '');
    }
  },
  methods: {
    // 兼容的Promise.allSettled实现
    promiseAllSettled(promises) {
      return Promise.all(promises.map(p =>
        Promise.resolve(p).then(
          value => ({ status: 'fulfilled', value }),
          reason => ({ status: 'rejected', reason })
        )
      ))
    },
    // 获取当前日期，格式为YYYY-MM-DD
    getCurrentDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const day = now.getDate()
      // 使用传统方法补零，避免padStart兼容性问题
      const monthStr = month < 10 ? '0' + month : '' + month
      const dayStr = day < 10 ? '0' + day : '' + day
      return year + '-' + monthStr + '-' + dayStr
    },
    logIcon(type) {
      const icons = {
        'info': 'el-icon-info',
        'success': 'el-icon-success',
        'error': 'el-icon-error',
        'warning': 'el-icon-warning'
      }
      return icons[type] || 'el-icon-info'
    },
    addLog(type, message) {
      const time = new Date().toLocaleTimeString()
      this.progress.logs.unshift({
        type,
        time,
        message
      })
      // 限制日志数量
      if (this.progress.logs.length > 100) {
        this.progress.logs = this.progress.logs.slice(0, 100)
      }
    },
    updateProgress() {
      if (this.progress.total === 0) return
      this.progress.percentage = Math.floor((this.progress.completed / this.progress.total) * 100)
      if (this.progress.percentage === 100) {
        this.progress.status = 'success'
      } else if (this.progress.failed > 0) {
        this.progress.status = 'exception'
      } else {
        this.progress.status = ''
      }
    },
    resetForm() {
      this.form = {
        area: '1',
        textListRaw: '',
        suffix: '',
        offset: 0
      }
      this.progress = {
        total: 0,
        completed: 0,
        success: 0,
        failed: 0,
        totalGroups: 0,
        modifiedGroups: 0,
        percentage: 0,
        status: '',
        logs: []
      }
      this.result.visible = false
    },
    async startBatchEdit() {
      // 验证输入
      if (!this.form.area) {
        this.$message.error('请选择地区')
        return
      }

      const textList = this.form.textList.length > 0 ? this.form.textList : this.form.textListRaw.split('\n').filter(item => item.trim() !== '')
      if (textList.length === 0) {
        this.$message.error('请输入至少一个账户名')
        return
      }

      if (!this.form.suffix) {
        this.$message.error('请输入后缀名称')
        return
      }

      const offset = parseInt(this.form.offset) || 0
      if (offset < 0) {
        this.$message.error('字符偏移量不能为负数')
        return
      }

      this.loading = true
      this.progress = {
        total: textList.length,
        completed: 0,
        success: 0,
        failed: 0,
        totalGroups: 0,
        modifiedGroups: 0,
        percentage: 0,
        status: '',
        logs: []
      }
      this.result.visible = false
      this.addLog('info', '开始批量修改广告组名称...')

      try {
        // 1. 获取区域cookie
        this.addLog('info', '正在获取区域cookie...')
        const regionCookie = await this.getRegionCookie(this.form.area)
        if (!regionCookie) {
          this.$message.error('获取区域cookie失败')
          this.loading = false
          return
        }
        this.addLog('success', '区域cookie获取成功')

        // 2. 并发处理每个账户
        const accounts = textList
        this.addLog('info', `开始处理 ${accounts.length} 个账户`)

        const concurrency = 5 // 并发数
        const batches = []
        for (let i = 0; i < accounts.length; i += concurrency) {
          batches.push(accounts.slice(i, i + concurrency))
        }

        const results = []
        for (let i = 0; i < batches.length; i++) {
          const batch = batches[i]
          this.addLog('info', `处理第 ${i + 1}/${batches.length} 批账户，共 ${batch.length} 个`)

          const batchResults = await this.promiseAllSettled(
            batch.map(account => this.processAccount(account, regionCookie, offset))
          )

          results.push(...batchResults)

          // 更新进度
          this.progress.completed += batch.length
          this.updateProgress()
        }

        // 3. 汇总结果
        this.summarizeResults(results)
        this.addLog('success', '批量修改完成')

      } catch (error) {
        console.error('批量修改失败:', error)
        this.addLog('error', `批量修改失败: ${error.message}`)
        this.$message.error('批量修改失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    async getRegionCookie(area) {
      try {
        const response = await this.$axios.get('https://control.zjwec.cn/api/hdcookie/page', {
          params: {
            pageNum: 1,
            uid: 1,
            role: 1,
            pageSize: 10,
            name: ''
          }
        })

        if (response.data.code === '0') {
          const records = response.data.data.records
          const areaMap = {
            '1': '浙江',
            '2': '福建',
            '3': '深圳',
            '4': '苏州'
          }
          const areaName = areaMap[area]
          const record = records.find(r => r.hdname === areaName)
          if (record) {
            return record.hdcookie
          }
        }
        return null
      } catch (error) {
        console.error('获取区域cookie失败:', error)
        return null
      }
    },
    async processAccount(account, regionCookie, offset) {
      try {
        this.addLog('info', `处理账户: ${account}`)

        // 1. 获取UUID
        const uuid = await this.getUUID(account, regionCookie)
        if (!uuid) {
          throw new Error('获取UUID失败')
        }
        this.addLog('success', `账户 ${account} UUID获取成功: ${uuid}`)

        // 2. 拼接cookie
        const fullCookie = this.buildFullCookie(regionCookie, uuid)

        // 3. 获取广告组列表
        const groupIds = await this.getAdGroupIds(fullCookie, uuid)
        if (groupIds.length === 0) {
          this.addLog('warning', `账户 ${account} 没有广告组`)
          return {
            account,
            success: true,
            groups: 0,
            message: '没有广告组'
          }
        }

        this.progress.totalGroups += groupIds.length
        this.addLog('info', `账户 ${account} 有 ${groupIds.length} 个广告组`)

        // 4. 并发修改广告组名称
        const modifiedCount = await this.batchEditGroupNames(groupIds, fullCookie, uuid, offset)

        this.progress.modifiedGroups += modifiedCount
        this.addLog('success', `账户 ${account} 修改了 ${modifiedCount}/${groupIds.length} 个广告组`)

        return {
          account,
          success: true,
          groups: modifiedCount,
          message: `成功修改 ${modifiedCount} 个广告组`
        }

      } catch (error) {
        console.error(`处理账户 ${account} 失败:`, error)
        this.addLog('error', `账户 ${account} 处理失败: ${error.message}`)
        return {
          account,
          success: false,
          groups: 0,
          error: error.message
        }
      }
    },
    async getUUID(account, cookie) {
      try {
        const response = await this.$axios.get('https://control.zjwec.cn/api/bindzh/getUUid', {
          params: {
            keyword: account,
            cookie: cookie
          }
        })

        if (response.data.retcode === 0 && response.data.data && response.data.data.length > 0) {
          return response.data.data[0].id
        }
        return null
      } catch (error) {
        console.error('获取UUID失败:', error)
        throw new Error('获取UUID失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message))
      }
    },
    buildFullCookie(originalCookie, uuid) {
      // 移除可能已存在的b_marketing_subid
      const cookieParts = originalCookie.split(';').map(part => part.trim())
      const filteredParts = cookieParts.filter(part => !part.startsWith('b_marketing_subid='))

      // 添加新的b_marketing_subid
      filteredParts.push(`b_marketing_subid=${uuid}`)

      return filteredParts.join('; ')
    },
    async getAdGroupIds(cookie, uuid) {
      const groupIds = []
      let pageIndex = 1
      const pageSize = 100

      try {
        while (true) {
          const timestamp = new Date().getTime()
          const response = await this.$axios.post('https://control.zjwec.cn/api/vivo/ad-group/list', {
            cookie: cookie,
            pageIndex: pageIndex,
            pageSize: pageSize,
            statisticsStart: this.getCurrentDate(),
            statisticsEnd: this.getCurrentDate(),
            timestamp: timestamp,
            sortColumn: 'gro.create_date',
            orderBy: 1,
            campaignId: '',
            status: '',
            name: '',
            indexId: '1,2,3,6,7,9,61,62,4,5,8,10,15,18,99,100,101',
            mediaType: '',
            chargeType: '',
            productId: '',
            id: '',
            adType: '',
            campaignType: '',
            campaignBudgetType: '',
            promotionType: '',
            campaignStatus: '',
            appPackageName: '',
            groupBudgetType: '',
            groupCreateDateStart: '',
            groupCreateDateEnd: ''
          })

          if (response.data.retcode === 0 && response.data.data && response.data.data.list) {
            const groups = response.data.data.list
            groups.forEach(group => {
              groupIds.push({
                id: group.id,
                name: group.name
              })
            })

            if (response.data.data.total <= pageIndex * pageSize) {
              break
            }
            pageIndex++
          } else {
            break
          }
        }
      } catch (error) {
        console.error('获取广告组列表失败:', error)
        throw new Error('获取广告组列表失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message))
      }

      return groupIds
    },
    async batchEditGroupNames(groupIds, cookie, uuid, offset) {
      let modifiedCount = 0
      const concurrency = 3 // 广告组并发数
      const batches = []

      for (let i = 0; i < groupIds.length; i += concurrency) {
        batches.push(groupIds.slice(i, i + concurrency))
      }

      for (let i = 0; i < batches.length; i++) {
        const batch = batches[i]
        const batchPromises = batch.map(group => this.editSingleGroup(group, cookie, uuid, offset))

        const results = await this.promiseAllSettled(batchPromises)

        results.forEach((result, index) => {
          const group = batch[index]
          if (result.status === 'fulfilled' && result.value) {
            modifiedCount++
            this.addLog('success', `广告组 ${group.id} 修改成功`)
          } else {
            this.addLog('error', `广告组 ${group.id} 修改失败: ${(result.reason && result.reason.message) || '未知错误'}`)
          }
        })
      }

      return modifiedCount
    },
    async editSingleGroup(group, cookie, uuid, offset) {
      try {
        // 1. 获取广告组详情
        const groupDetail = await this.getGroupDetail(group.id, cookie, uuid)
        if (!groupDetail) {
          throw new Error('获取广告组详情失败')
        }

        // 2. 修改名称
        const newName = this.modifyGroupName(groupDetail.name, offset)
        groupDetail.name = newName

        // 3. 调用编辑接口
        await this.editGroup(group.id, groupDetail, cookie, uuid)

        return true

      } catch (error) {
        console.error(`修改广告组 ${group.id} 失败:`, error)
        throw error
      }
    },
    async getGroupDetail(groupId, cookie, uuid) {
      const timestamp = new Date().getTime()
      const response = await this.$axios.get('https://control.zjwec.cn/api/vivo/ad-group/detail', {
        params: {
          id: groupId,
          timestamp: timestamp,
          cookie: cookie
        },
        headers: {
          'Referer': `https://ad.vivo.com.cn/marketing/ads/edit/2/${groupId}`
        }
      })

      if (response.data.retcode === 0 && response.data.data) {
        return response.data.data
      }
      return null
    },
    modifyGroupName(originalName, offset) {
      let baseName = originalName
      if (offset > 0 && baseName.length > offset) {
        baseName = baseName.substring(0, baseName.length - offset)
      }
      return baseName + this.form.suffix
    },
    async editGroup(groupId, groupData, cookie, uuid) {
      const timestamp = new Date().getTime()

      // 根据后端接口要求，所有参数都通过请求体传递
      // 将cookie和timestamp添加到groupData中
      const requestData = {
        ...groupData,
        cookie: cookie,
        timestamp: timestamp
      }

      const response = await this.$axios.post('https://control.zjwec.cn/api/vivo/ad-group/edit', requestData, {
        headers: {
          'Referer': `https://ad.vivo.com.cn/marketing/ads/edit/2/${groupId}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.data.retcode !== 0) {
        throw new Error(response.data.message || '编辑广告组失败')
      }

      return response.data
    },
    summarizeResults(results) {
      const successDetails = []
      const failedDetails = []

      results.forEach(result => {
        if (result.status === 'fulfilled') {
          const value = result.value
          if (value.success) {
            this.progress.success++
            successDetails.push(value)
          } else {
            this.progress.failed++
            failedDetails.push(value)
          }
        } else {
          this.progress.failed++
          failedDetails.push({
            account: '未知',
            error: (result.reason && result.reason.message) || '未知错误'
          })
        }
      })

      this.result = {
        visible: true,
        total: this.progress.total,
        success: this.progress.success,
        failed: this.progress.failed,
        failedDetails,
        successDetails
      }
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
  font-size: 16px;
}

.main-card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-size: 16px;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.input-section {
  padding: 20px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 16px;
}

.el-form-item__tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.progress-section {
  margin-top: 20px;
}

.progress-info {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.progress-item {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 6px;
  border-left: 4px solid #409eff;
}

.progress-item span:first-child {
  color: #666;
  margin-right: 5px;
}

.progress-value {
  font-weight: bold;
  font-size: 18px;
}

.progress-value.success {
  color: #67c23a;
}

.progress-value.failed {
  color: #f56c6c;
}

.progress-log {
  margin-top: 20px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 6px;
  font-size: 14px;
  max-height: 300px;
  overflow-y: auto;
}

.log-item {
  margin: 5px 0;
  padding: 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.log-item i {
  margin-right: 8px;
}

.log-item.info {
  color: #909399;
}

.log-item.success {
  color: #67c23a;
  background-color: #f0f9eb;
}

.log-item.error {
  color: #f56c6c;
  background-color: #fef0f0;
}

.log-item.warning {
  color: #e6a23c;
  background-color: #fdf6ec;
}

.log-item span {
  margin-right: 10px;
}

.result-section {
  margin-top: 20px;
}

.result-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  background: linear-gradient(135deg, #f8fafe, #e8f1ff);
  border-radius: 12px;
  border: 1px solid #e4e9ff;
}

.result-stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}

.result-stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.result-stat-icon i {
  font-size: 28px;
  color: white;
}

.success .result-stat-icon {
  background: linear-gradient(135deg, #409eff, #85ce61);
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
}

.failed .result-stat-icon {
  background: linear-gradient(135deg, #f56c6c, #f78989);
  box-shadow: 0 4px 12px rgba(245, 108, 108, 0.3);
}

.total .result-stat-icon {
  background: linear-gradient(135deg, #909399, #c0c4cc);
  box-shadow: 0 4px 12px rgba(144, 147, 153, 0.3);
}

.result-stat-number {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 4px;
}

.success .result-stat-number {
  color: #67c23a;
}

.failed .result-stat-number {
  color: #f56c6c;
}

.total .result-stat-number {
  color: #909399;
}

.result-stat-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.result-divider {
  width: 1px;
  height: 60px;
  background: linear-gradient(to bottom, transparent, #c0c4cc, transparent);
  margin: 0 20px;
}

.failed-details,
.success-details {
  margin-top: 20px;
}

.failed-details h3,
.success-details h3 {
  color: #333;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 2px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/vivo/BatchEditGroupName.vue